enum Language {
  DE = 0,
  EN = 1,
  FR = 2,
  IT = 3
}

export default Language;
